<template>
    <div class="horse-preview-owners flex justify-content-evenly m-3">
        <div class="flex flex-column w-3">
            <div class="label">{{ $t('message.horsePreview.owners.breeders') }}</div>
            <div v-for="breeder in selectedHorse.breeders" :key="breeder.id" class="value">{{ breeder }}</div>
        </div>
        <div class="flex flex-column w-3">
            <div class="label">{{ $t('message.horsePreview.owners.owners') }}</div>
            <div v-for="owner in selectedHorse.owners" :key="owner.id" class="value">{{ owner }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HorsePreviewOwners",
    props: {
        selectedHorse: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
.horse-preview-owners {
    .label {
        font-size: 19px;
        text-transform: uppercase;
        font-weight: 600;
    }
    .value {
        font-family: var(--decor-font-family);
        font-size: 23px;
    }
}
</style>
